

















import { Vue, Component } from 'vue-property-decorator';

@Component
export default class PreView extends Vue {
  data = `<p>&ldquo;紫荆杯&rdquo;两岸暨港澳青少年书画大赛前身是&ldquo;紫荆杯&rdquo;两岸四地青少年书画大赛，已举办过五届：</p>
<p>◎2011年在香港和内地相关部门及社会各界的支持下，举办第一届&ldquo;紫荆杯&rdquo;两地青少年书画大赛，得到香港及内地青少年的积极回应，收到3,000多幅参赛作品。</p>
<p>◎2012年应台湾和澳门地区教育机构之请求，大赛规模扩展至两岸暨港澳（中国内地、香港、澳门、台湾），共收到5,000多幅作品。</p>
<p>◎2014年以中华人民共和国成立65周年为契机，举办了规模更大、规格更高、影响更广泛的第三届&ldquo;紫荆杯&rdquo;两岸四地青少年书画大赛，总计收到逾万件参赛作品，仅香港选送作品就超过1,000件，内地有17个省、直辖市、自治区组织学生参赛。</p>
<p>◎2016 年举办的第四届&ldquo;紫荆杯&rdquo;两岸四地青少年书画大赛，反响极为热烈，尤其内地多省举办分区赛，好中选优，推送优秀作品；香港报名情况更超过往届，参赛作品逾20,000件。</p>
<p>◎2018年举办的第五届&ldquo;紫荆杯&rdquo;两岸暨港澳青少年书画大赛。大赛首次与与新浪微博联合主办，开通网络报名管道并首次推行网络人次评选，进一步拓展该大赛的品牌影响力及号召力，报名参赛超过50,000人。</p>`;
  imgContent = [
    {
      src:
        'https://image2.cqcb.com/d/file/topics/activity/2020-07-15/3QmVN6gm-1594783484905.jpg',
      desc: '香港特区教育局局长杨润雄先生在颁奖典礼致辞',
    },
    {
      src:
        'https://image2.cqcb.com/d/file/topics/activity/2020-07-15/e9mm8WrG-1594783485099.jpg',
      desc: '获奖学生在颁奖典礼代表发言',
    },
    {
      src:
        'https://image2.cqcb.com/d/file/topics/activity/2020-07-15/0mU8abQd-1594783485325.jpg',
      desc: '中央政府驻港联络办副主任杨健先生为获奖学生颁奖',
    },
    {
      src:
        'https://image2.cqcb.com/d/file/topics/activity/2020-07-15/kb9Iban6-1594783485520.png',
      desc: '获奖学生及颁奖嘉宾合影留念',
    },
  ];
  workContent = [
    {
      src:
        'https://image2.cqcb.com/d/file/topics/activity/2020-07-15/GWBLLZY0-1594784139286.jpg',
      desc: '《乐》高永宁（香港）圆玄小学',
    },
    {
      src:
        'https://image2.cqcb.com/d/file/topics/activity/2020-07-15/o3KDLW5U-1594784139468.jpg',
      desc: '《东方之珠》何美錞（香港）保良局朱正贤小学',
    },
    {
      src:
        'https://image2.cqcb.com/d/file/topics/activity/2020-07-15/vhA8OPcl-1594784139671.jpg',
      desc: '《村落》詹子琦（福建）福建省美术家协会',
    },
    {
      src:
        'https://image2.cqcb.com/d/file/topics/activity/2020-07-15/JymyefXL-1594784139855.jpg',
      desc: ' 《哺》何婷（香港）香港王肇枝中学',
    },
    {
      src:
        'https://image2.cqcb.com/d/file/topics/activity/2020-07-15/v91f0gq1-1594784140039.jpg',
      desc: '《莫道》胡小玲（广东）广东省东莞市茶山镇冠华学校',
    },
    {
      src:
        'https://image2.cqcb.com/d/file/topics/activity/2020-07-15/7AsqdrF5-1594784140216.jpg',
      desc: '《楹联》刘韩宇（四川）四川省成都市红牌楼小学',
    },
  ];
}
